export const faqs = [
  {
    question: 'What are AI workflow automation services?',
    answer:
      'They are professional services that design, build and run automated business processes enhanced with AI. A provider typically maps your current workflow, connects the systems involved, adds AI models to handle unstructured inputs and judgement-based steps, and sets up human approval, monitoring and ongoing optimisation.',
  },
  {
    question: 'How is AI workflow automation different from RPA?',
    answer:
      'Robotic process automation mimics clicks and keystrokes to move structured data between screens. AI workflow automation works through APIs and integrations and adds models that can read documents, understand language and recommend actions, so it copes with variable, unstructured work that rules-based RPA struggles with.',
  },
  {
    question: 'How long does an AI workflow automation project take?',
    answer:
      'It depends on scope and system complexity. A focused proof of concept on a single process can often be delivered in a matter of weeks, while a production rollout across several integrated systems takes longer. Ask each provider for a phased plan with clear milestones and success criteria.',
  },
  {
    question: 'Is AI workflow automation compliant with UK GDPR?',
    answer:
      'It can be, provided it is designed that way. Look for data minimisation, a lawful basis for processing, data processing agreements, role-based access, audit logs and human review of decisions that significantly affect people. The ICO publishes guidance on AI and data protection that is worth reviewing with your provider.',
  },
  {
    question: 'Do we need to replace our existing systems?',
    answer:
      'Usually not. Most AI workflow automation connects to the CRM, ERP, helpdesk, email and document tools you already use. Replacement is only worth considering when a legacy system offers no reliable way to integrate.',
  },
  {
    question: 'Which processes should we automate first?',
    answer:
      'Start with high-volume, repetitive processes that have a clear owner, a measurable baseline and manageable risk, such as invoice handling, ticket triage, lead routing or document intake. Avoid starting with the most sensitive decision in the business.',
  },
  {
    question: 'How do we measure the ROI of AI workflow automation?',
    answer:
      'Record a baseline before launch, then track cycle time, hours returned to the team, cost per transaction, error and rework rates, exception rates and adoption. Compare the annual value created against total cost, including licences, build, hosting and maintenance.',
  },
  {
    question: 'Why is tkxel listed first in this guide?',
    answer:
      'This order is our editorial assessment, not a third-party ranking. tkxel is listed first because its publicly described offering spans the full lifecycle, from process discovery and proof of concept to implementation, AI agents, integrations, human approval steps, monitoring and optimisation, which suits organisations looking for one accountable partner.',
  },
];
